<aside class="agentix-trial-marketing-panel">
  <div class="agentix-trial-marketing-panel__visual">
    <div class="agentix-trial-marketing-panel__visual-content">
      @if (activeSlide === 0) {
        <div class="agentix-trial-marketing-panel__slide"
          [class.agentix-trial-marketing-panel__slide--active]="activeSlide === 0"
          >
          <div class="trial-visual trial-visual--trial">
            <div class="trial-visual__hero">
              <div class="trial-visual__orb"
                aria-hidden="true">
                <video class="trial-visual__orb-video"
                  autoplay
                  loop
                  muted
                  playsinline
                  poster="assets/img/ai/ai-agentix-logo-circle.svg">
                  <source src="assets/img/ai/agentix_logo.mp4"
                    type="video/mp4">
                    <img src="assets/img/ai/ai-agentix-logo-circle.svg"
                      alt=""
                      class="trial-visual__orb-image" />
                    </video>
                  </div>
                  <div class="trial-visual__bars-ring">
                    <div class="trial-visual__bar-pill trial-visual__bar-pill--agents">
                      <div class="trial-visual__bar-row">
                        <span class="trial-visual__bar-label">{{ 'ai_agents' | translate }}</span>
                        <em>1 / 3</em>
                      </div>
                      <div class="trial-visual__track">
                        <div class="trial-visual__fill trial-visual__fill--blue"
                        style="width: 33%"></div>
                      </div>
                    </div>
                    <div class="trial-visual__bar-pill trial-visual__bar-pill--tokens">
                      <div class="trial-visual__bar-row">
                        <span class="trial-visual__bar-label">{{ 'credits' | translate }}</span>
                        <em>1M / 3M</em>
                      </div>
                      <div class="trial-visual__track">
                        <div class="trial-visual__fill trial-visual__fill--green"
                        style="width: 33%"></div>
                      </div>
                    </div>
                    <div class="trial-visual__bar-pill trial-visual__bar-pill--users">
                      <div class="trial-visual__bar-row">
                        <span class="trial-visual__bar-label">{{ 'users' | translate }}</span>
                        <em>2 / 3</em>
                      </div>
                      <div class="trial-visual__track">
                        <div class="trial-visual__fill trial-visual__fill--orange"
                        style="width: 66%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="trial-visual__glass-card trial-visual__glass-card--horizontal">
                    <div class="trial-visual__glass-icon">
                      <mat-icon svgIcon="free-trial"
                      aria-hidden="true"></mat-icon>
                    </div>
                    <div class="trial-visual__glass-copy">
                      <strong>{{ 'free_trial' | translate }}</strong>
                      <p>{{ 'agentix_trial_signup_slide_0_card_subtext' | translate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (activeSlide === 1) {
            <div class="agentix-trial-marketing-panel__slide"
              [class.agentix-trial-marketing-panel__slide--active]="activeSlide === 1"
              >
              <div class="trial-visual trial-visual--imag mb-5">
                <img class="trial-visual__step-image"
                  src="assets/img/ai/validate-step.png"
                  alt="">
                </div>
              </div>
            }

            @if (activeSlide === 2) {
              <div class="agentix-trial-marketing-panel__slide"
                [class.agentix-trial-marketing-panel__slide--active]="activeSlide === 2"
                >
                <div class="trial-visual trial-visual--image mb-5">
                  <img class="trial-visual__step-image"
                    src="assets/img/ai/profile-step.png"
                    alt="">
                  </div>
                </div>
              }

              @if (activeSlide === 3) {
                <div class="agentix-trial-marketing-panel__slide"
                  [class.agentix-trial-marketing-panel__slide--active]="activeSlide === 3"
                  >
                  <div class="trial-visual trial-visual--image mb-5">
                    <img class="trial-visual__step-image"
                      src="assets/img/ai/profile-step.png"
                      alt="">
                    </div>
                  </div>
                }

                @if (activeSlide === 4) {
                  <div class="agentix-trial-marketing-panel__slide"
                    [class.agentix-trial-marketing-panel__slide--active]="activeSlide === 4"
                    >
                    <div class="trial-visual trial-visual--image">
                      <img class="trial-visual__step-image"
                        src="assets/img/ai/last-step.png"
                        alt="">
                      </div>
                    </div>
                  }
                </div>
                <div class="agentix-trial-marketing-panel__copy">
                  <h2>{{ slides[activeSlide].headlineKey | translate }}</h2>
                  <p>{{ slides[activeSlide].subtextKey | translate }}</p>
                </div>

                <div class="agentix-trial-marketing-panel__dots"
                  role="tablist"
                  aria-label="Marketing slides">
                  @for (slide of slides; track slide; let i = $index) {
                    <span
                      class="agentix-trial-marketing-panel__dot"
                      [class.agentix-trial-marketing-panel__dot--active]="activeSlide === i"
                    [attr.aria-current]="activeSlide === i ? 'true' : null"></span>
                  }
                </div>
              </div>
            </aside>
